import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Token de contexto HTTP para desabilitar o retry automático de contexto perdido.
 * Use quando o serviço já trata o 422 de forma específica.
 */
export const SKIP_CONTEXT_RECOVERY = new HttpContextToken<boolean>(() => false);

/**
 * Interceptor de 422/403 por contexto perdido (headers app-context/User-Access
 * vazios). Não faz mais retry de recuperação — o fluxo OAuth2 atual (code+state)
 * nunca preenche os parâmetros que esse retry dependia, então hoje só repassa o
 * erro adiante. `SKIP_CONTEXT_RECOVERY` segue disponível para quem trata 422/403
 * manualmente.
 */
@Injectable()
export class ContextRecoveryInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(SKIP_CONTEXT_RECOVERY)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
}
